const LoadingSpinner = ({
    height = "h-64",
  }) => {
    return (
      <div
        className={`flex justify-center items-center ${height}`}
      >
        <div className="animate-spin rounded-full h-14 w-14 border-4 border-gray-300 border-t-blue-500" />
      </div>
    );
  };
  
  export default LoadingSpinner;